<template>
  <div>
    <div :class="[$style.tabs, $style.mainTabs]">
      <button
        v-for="(value, i) in values"
        :key="i"
        :class="[$style.tab, { [$style.tabActive]: index === i }]"
        @click="select(i)"
      >
        {{ value.title }}
      </button>
    </div>
    <template v-for="(value, i) in values" :key="i">
      <div :class="$style.tabs">
        <button :class="[$style.tab, $style.tabActive]">
          {{ value.title }}
        </button>
      </div>
      <div v-show="index === i" :class="$style.content">
        <p>{{ getDesc(i) }}</p>
      </div>
    </template>
  </div>
  <slot name="after" :index="index" />
</template>

<script>
import { defineComponent } from 'vue';
import get from 'lodash/get';

export default defineComponent({
  props: {
    values: { type: Array, default: () => [] },
  },
  data() {
    return { index: 0 };
  },
  methods: {
    getDesc(i) {
      return get(this.values, `${i}.description`) || '—';
    },
    select(i) {
      this.index = i;
    },
  },
});
</script>

<style lang="scss" module>
.mainTabs {
  @media print {
    display: none !important;
  }
  & ~ .tabs {
    @media not print {
      display: none;
    }
  }
}
.tab {
  font-size: 12px;

  color: #2f3543;
  border-top: 1.3px solid transparent;
  border-bottom: 1.3px solid transparent;
  margin: -1.3px 0;

  & + .tab {
    margin-left: 10px;
  }

  @media print {
    color: #575757;
  }
}
.tabActive {
  font-weight: bold;
  border-bottom-color: #2f3543;

  @media print {
    border-bottom-color: #575757;
  }
}
.tabs {
  border-top: 1px solid transparent;
  display: flex;
}
.content {
  border-bottom: 1px solid rgba(47, 53, 67, 0.11);
  border-top: 1px solid rgba(47, 53, 67, 0.11);

  padding: 10px 0;
  font-size: 12px;
  line-height: 125%;

  color: rgba(47, 53, 67, 0.6);
  & + .tabs {
    margin-top: 10px;
  }

  @media print {
    display: block !important;
    border-bottom: none;
    padding-bottom: 0;
  }
}
</style>
